// OBX Custom Image Modal
document.addEventListener("DOMContentLoaded", function () {
  // Get HTML Elements
  const body_element = document.body;
  var modal_triggers = document.getElementsByClassName("obx-modal-trigger");

  // Create Background Overlay + Add to Body
  const obx_overlay = document.createElement("div");
  obx_overlay.id = "obx-overlay";
  document.body.appendChild(obx_overlay);

  // Create Empty Modal + Add to Body
  const imgModal = document.createElement("div");
  imgModal.id = "obx-img-modal";
  obx_overlay.after(imgModal);

  // If there are modals on page
  if (modal_triggers.length > 0) {
    var i;
    for (i = 0; i < modal_triggers.length; i++) {
      // Make 'em Click
      modal_triggers[i].addEventListener("click", function () {
        // Assign Attribute to Modal
        var modal_id = this.getAttribute("obx-img-modal");
        imgModal.setAttribute("obx-img-modal", modal_id);

        // Find DIV with Image
        const modal_data = this.closest(".modal-trigger-container");

        // Get Image from Div to Add to Modal
        if (modal_data) {
          const modal_image = modal_data.querySelector("img");

          // Make sure there's an image
          if (modal_image) {
            // Add image to modal
            imgModal.appendChild(modal_image.cloneNode(true));

            // So clicking on image doesn't close modal
            imgModal.querySelector("img").addEventListener("click", function () {
                event.stopPropagation();
            });

            // Enable Background Overlay
            body_element.style.position = "relative";
            obx_overlay.classList.add("active");
            imgModal.classList.add("active");

            // Click Overlay to Close + Empty Modal, Hide Overlay
            imgModal.addEventListener("click", function () {
              obx_overlay.classList.remove("active");
              imgModal.classList.remove("active");
              imgModal.innerHTML = "";
              imgModal.setAttribute("obx-img-modal", "");
            });
          }
        }
      });
    }
  }
});